import { css, keyframes } from 'styled-components'

/**
 *
 */
const fadeInFrames = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const fadeOutFrames = keyframes`
  to { opacity: 1; }
  from { opacity: 0; }
`

export const fadeIn = css`
  animation: ${fadeInFrames} 1.5s linear infinite alternate;
`

export const fadeOut = css`
  animation: ${fadeOutFrames} 1.5s linear infinite alternate;
`
